import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class CurrentComponentIdService {
  private currentComponentId: string;

  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // eslint-disable-next-line prefer-destructuring
        this.currentComponentId = event.url.split('/')[3]?.split('?')[0];
      }
    });
  }

  get(): string {
    return this.currentComponentId;
  }
}
